import { useEffect, useState } from "react"

export const useHeaderVisibility = (isFixed: boolean) => {
  useEffect(() => {
    const header = document.getElementById("header")
    if (!header) return

    header.className = isFixed ? "d-none" : "d-block"
  }, [isFixed])
}
